
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 4.594v22.813l-1.719-1.688L8.562 21H3.999V11h4.563l4.719-4.719zm-2 4.844l-3.281 3.281-.313.281H6v6h3.406l.313.281L13 22.562V9.437zm7.219 2.343L23 14.562l2.781-2.781 1.438 1.438L24.438 16l2.781 2.781-1.438 1.438L23 17.438l-2.781 2.781-1.438-1.438L21.562 16l-2.781-2.781z"}})])
          )
        }
      }
    